import Resource from '@/api/resources/Resource'
import { PAGINATOR_BIG_PAGE_SIZE } from '@/shared/services/services-constants'

class ClinicalRequestPrintService extends Resource {
    async getRequestReportPdfForPrinting(requestIds) {
        return this.axios.get(`/clinical/laboratories/requests/reports`,
            {
                params: {
                    listReqIds: requestIds.join(','),
                    encoded: true
                }
            }).then(response => response.data)
    }

    async downloadRequestReportPdf(requestIds) {
        return this.axios.get(`/clinical/laboratories/requests/reports`,
            {
                headers: {
                    type: 'application/pdf'
                },
                params: {
                    listReqIds: requestIds.join(','),
                    encoded: false
                },
                responseType: 'arraybuffer'
            }).then(response => response.data)
    }

    async exportTo(url, sectionLabel, filterModel, sortModel, columns, selectedIds, exportType) {
        const params = {
            page: 0,
            size: PAGINATOR_BIG_PAGE_SIZE,
            sort: sortModel,
            exportType
        }
        return this.axios.put(
            `${url}/exportToPdf`,
            { sectionLabel, filterModel, columns, entityIdentifiersRequest: selectedIds },
            { params, responseType: 'arraybuffer' })
    }
}

export default new ClinicalRequestPrintService()
